import React, { useState, useEffect, useRef } from "react";

import {
  Clock,
  DollarSign,
  Filter,
  HardHat,
  Heart,
  MapPin,
  Search,
  User,
  Eye,
  MessageSquare,
  Bookmark,
  Grid,
  List,
} from "lucide-react"
import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar"
import { Badge } from "../../_newprofiles/components/ui/Badge"
import { Button } from "../../_newprofiles/components/ui/Button"
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card"
import { Input } from "../../_newprofiles/components/ui/Input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../_newprofiles/components/ui/Select"
import { Separator } from "../../_newprofiles/components/ui/Separator"
import styles from "./JobsDesign.module.css"
import jobstyles from "../JobDashboard/NewHomeUserJobsDashboard.module.css"

const JobsPage = () => {

  const [selectedJob, setSelectedJob] = useState(1)

  const jobs = [
    {
      id: 1,
      title: "Complete Kitchen Renovation - Modern Design",
      description:
        "Looking for an experienced contractor to completely renovate our kitchen. This includes removing existing cabinets, installing new custom cabinets, granite countertops, new appliances, flooring, and electrical work. We want a modern, open-concept design with an island.",
      client: "Sarah Johnson",
      location: "Bondi Beach, NSW 2026",
      budget: "$25,000 - $35,000",
      posted: "2 hours ago",
      deadline: "Start within 2 weeks",
      category: "Kitchen Renovation",
      urgent: true,
      images: ["/placeholder.svg?height=200&width=300", "/placeholder.svg?height=200&width=300"],
      requirements: ["Licensed contractor", "Insurance required", "References needed"],
      siteVisit: "Available weekends",
      responses: 12,
      views: 45,
    },
    {
      id: 2,
      title: "Bathroom Tiling and Waterproofing Project",
      description:
        "Need professional tiling work for a master bathroom renovation. Includes waterproofing, floor and wall tiling, shower installation, and finishing work. High-quality materials will be provided.",
      client: "Mike Chen",
      location: "Parramatta, NSW 2150",
      budget: "$8,000 - $12,000",
      posted: "5 hours ago",
      deadline: "Flexible timing",
      category: "Bathroom Renovation",
      urgent: false,
      images: ["/placeholder.svg?height=200&width=300"],
      requirements: ["Waterproofing certification", "Tiling experience", "Own tools"],
      siteVisit: "Weekdays preferred",
      responses: 8,
      views: 23,
    },
    // Add more jobs as needed
  ]

  const selectedJobData = jobs.find((job) => job.id === selectedJob)

  return (
    <div className={styles.jobsPage}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            <div className={styles.headerLeft}>
              <div className={styles.logo}>
                <HardHat className={styles.logoIcon} />
                <span className={styles.logoText}>Build Start</span>
              </div>
              <Separator orientation="vertical" className={styles.separator} />
              <h1 className={styles.pageTitle}>Job Opportunities</h1>
            </div>
            <div className={styles.headerRight}>
              <Badge variant="secondary" className={styles.activeJobsBadge}>
                {jobs.length} Active Jobs
              </Badge>
              <Avatar>
                <AvatarImage src="/placeholder-user.jpg" />
                <AvatarFallback className={styles.avatarFallback}>JD</AvatarFallback>
              </Avatar>
            </div>
          </div>
        </div>
      </header>


        {/* Search and Filter */}
        <div className={jobstyles.jobDashboard_card + ' ' + jobstyles.jobDashboard_mb8}>
          <div className={jobstyles.jobDashboard_cardContent}>
            <div className={jobstyles.jobDashboard_searchFilterContainer}>
              <div className={jobstyles.jobDashboard_searchInputContainer}>
                <span className={jobstyles.jobDashboard_searchInputIcon + ' ' + jobstyles.jobDashboard_textGray400}>🔍</span> {/* Search icon */}
                <input
                  type="text"
                  placeholder="Search by name, description, category..."
                  className={jobstyles.jobDashboard_input + ' ' + jobstyles.jobDashboard_searchInputMain}
                  value={"searchTerm"}
                  />
              </div>
              <div className={jobstyles.jobDashboard_filterButtons}>
                <button
                  className={jobstyles.jobDashboard_btn + ' ' + jobstyles.jobDashboard_btnOutline + ' ' + jobstyles.jobDashboard_btnSm}
                  
                >
                  <span className={jobstyles.jobDashboard_h4 + ' ' + jobstyles.jobDashboard_w4 + ' ' + jobstyles.jobDashboard_mr2}>📅</span> {/* Calendar icon */}
                  Sort by Date
                </button>
                <button
                  className={jobstyles.jobDashboard_btn + ' ' + jobstyles.jobDashboard_btnOutline + ' ' + jobstyles.jobDashboard_btnSm}
                  
                >
                  <span className={jobstyles.jobDashboard_h4 + ' ' + jobstyles.jobDashboard_w4 + ' ' + jobstyles.jobDashboard_mr2}>💰</span> {/* DollarSign icon */}
                  Sort by Budget
                </button>
                <button
                  className={jobstyles.jobDashboard_btn + ' ' + jobstyles.jobDashboard_btnOutline + ' ' + jobstyles.jobDashboard_btnSm}
                  
                >
                  <span className={jobstyles.jobDashboard_h4 + ' ' + jobstyles.jobDashboard_w4 + ' ' + jobstyles.jobDashboard_mr2}>🏷️</span> {/* Tag icon */}
                  Sort by Category
                </button>
              </div>
            </div>
          </div>
        </div>


      {/* Alternative filters */}
      <div className={styles.container}>
        {/* Search and Filters */}
        <Card className={styles.searchCard}>
          <CardContent className={styles.searchCardContent}>
            <div className={styles.searchFilterContainer}>
              <div className={styles.searchInputContainer}>
                <Search className={styles.searchIcon} />
                <Input placeholder="Search jobs..." className={styles.searchInput} />
              </div>
              <div className={styles.filtersGrid}>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Location" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="sydney">Sydney</SelectItem>
                    <SelectItem value="melbourne">Melbourne</SelectItem>
                    <SelectItem value="brisbane">Brisbane</SelectItem>
                  </SelectContent>
                </Select>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Category" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="kitchen">Kitchen Renovation</SelectItem>
                    <SelectItem value="bathroom">Bathroom Renovation</SelectItem>
                    <SelectItem value="roofing">Roofing</SelectItem>
                    <SelectItem value="extension">Home Extension</SelectItem>
                  </SelectContent>
                </Select>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Budget Range" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0-5k">$0 - $5,000</SelectItem>
                    <SelectItem value="5k-15k">$5,000 - $15,000</SelectItem>
                    <SelectItem value="15k-50k">$15,000 - $50,000</SelectItem>
                    <SelectItem value="50k+">$50,000+</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className={styles.filterActions}>
              <div className={styles.filterButtons}>
                <Button variant="outline" size="sm">
                  <Filter className="h-4 w-4 mr-2" />
                  More Filters
                </Button>
                <Button variant="outline" size="sm">
                  Urgent Jobs Only
                </Button>
              </div>
              <div className={styles.viewOptions}>
                <span className={styles.viewLabel}>View:</span>

              </div>
            </div>
          </CardContent>
        </Card>

        {/* Jobs Layout */}

          <div className={styles.jobsLayout}>
            {/* Jobs List */}
            <div className={styles.jobsList}>
              {jobs.map((job) => (
                <Card
                  key={job.id}
                  className={`${styles.jobCard} ${
                    selectedJob === job.id ? styles.jobCardSelected : ""
                  }`}
                  onClick={() => setSelectedJob(job.id)}
                >
                  <CardContent className={styles.jobCardContent}>
                    <div className={styles.jobCardHeader}>
                      <div className="flex-1">
                        <div className={styles.jobTitleContainer}>
                          <h3 className={styles.jobTitle}>{job.title}</h3>
                          {job.urgent && (
                            <Badge variant="destructive" className={styles.urgentBadge}>
                              Urgent
                            </Badge>
                          )}
                        </div>
                        <div className={styles.jobMeta}>
                          <div className={styles.jobMetaItem}>
                            <User className="h-4 w-4" />
                            <span>{job.client}</span>
                          </div>
                          <div className={styles.jobMetaItem}>
                            <MapPin className="h-4 w-4" />
                            <span>{job.location}</span>
                          </div>
                          <div className={styles.jobMetaItem}>
                            <Clock className="h-4 w-4" />
                            <span>{job.posted}</span>
                          </div>
                        </div>
                        <p className={styles.jobDescription}>{job.description}</p>
                        <div className={styles.jobFooter}>
                          <div className={styles.jobBudgetContainer}>
                            <div className={styles.jobBudget}>
                              <DollarSign className="h-4 w-4" />
                              <span>{job.budget}</span>
                            </div>
                            <Badge variant="secondary">{job.category}</Badge>
                          </div>
                          <div className={styles.jobStats}>
                            <div className={styles.jobStatItem}>
                              <Eye className="h-4 w-4" />
                              <span>{job.views}</span>
                            </div>
                            <div className={styles.jobStatItem}>
                              <MessageSquare className="h-4 w-4" />
                              <span>{job.responses}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Job Details Panel */}
            <div className={styles.jobDetailsPanel}>
              {selectedJobData && (
                <Card className={styles.detailsCard}>
                  <CardHeader className={styles.detailsCardHeader}>
                    <CardTitle className={styles.detailsCardTitle}>
                      <span>Job Details</span>
                      <Button variant="ghost" size="icon" className={styles.bookmarkButton}>
                        <Bookmark className="h-4 w-4" />
                      </Button>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className={styles.detailsCardContent}>
                    <div className={styles.detailsContent}>
                      <div className={styles.detailsSection}>
                        <h3 className={styles.detailsTitle}>{selectedJobData.title}</h3>
                        <p className={styles.detailsDescription}>{selectedJobData.description}</p>
                      </div>

                      <Separator />

                      <div className={styles.detailsGrid}>
                        <div className={styles.detailItem}>
                          <h4 className={styles.detailLabel}>Budget</h4>
                          <p className={`${styles.detailValue} ${styles.detailValueBudget}`}>{selectedJobData.budget}</p>
                        </div>
                        <div className={styles.detailItem}>
                          <h4 className={styles.detailLabel}>Deadline</h4>
                          <p className={styles.detailValue}>{selectedJobData.deadline}</p>
                        </div>
                        <div className={styles.detailItem}>
                          <h4 className={styles.detailLabel}>Site Visit</h4>
                          <p className={styles.detailValue}>{selectedJobData.siteVisit}</p>
                        </div>
                        <div className={styles.detailItem}>
                          <h4 className={styles.detailLabel}>Category</h4>
                          <Badge variant="secondary">{selectedJobData.category}</Badge>
                        </div>
                      </div>

                      <Separator />

                      <div className={styles.detailsSection}>
                        <h4 className={styles.detailLabel}>Requirements</h4>
                        <ul className={styles.requirementsList}>
                          {selectedJobData.requirements.map((req, index) => (
                            <li key={index} className={styles.requirementItem}>
                              <div className={styles.requirementBullet}></div>
                              <span>{req}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {selectedJobData.images.length > 0 && (
                        <>
                          <Separator />
                          <div className={styles.detailsSection}>
                            <h4 className={styles.detailLabel}>Project Images</h4>
                            <div className={styles.projectImagesGrid}>
                              {selectedJobData.images.map((image, index) => (
                                <img
                                  key={index}
                                  src={image || "/placeholder.svg"}
                                  alt={`Project image ${index + 1}`}
                                  className={styles.projectImage}
                                />
                              ))}
                            </div>
                          </div>
                        </>
                      )}

                      <Separator />

                      <div className={styles.actionsContainer}>
                        <Button className={styles.submitButton}>Submit Proposal</Button>
                        <Button variant="outline" className={styles.messageButton}>
                          <MessageSquare className="h-4 w-4 mr-2" />
                          Message Client
                        </Button>
                        <div className={styles.actionButtons}>
                          <Button variant="outline" size="sm" className="flex-1">
                            <Heart className="h-4 w-4 mr-2" />
                            Save
                          </Button>
                          <Button variant="outline" size="sm" className="flex-1">
                            Share
                          </Button>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>

      </div>
    </div>
  )
}

export default JobsPage
